
import React from 'react';

const ShrineAuth = () => {
  return (
    <div 
      className="fixed inset-0 flex items-center justify-center"
      style={{ 
        backgroundImage: 'url(/lovable-uploads/e2828d12-01c6-4a10-8602-e50dc1ddad71.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: -1
      }}
    >
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      <div className="relative z-10 text-center text-cyan-300">
        <h1 className="text-4xl font-bold mb-4">THE SHRINE</h1>
        <p>Please sign in to interact with the Shrine</p>
      </div>
    </div>
  );
};

export default ShrineAuth;
